import { render, staticRenderFns } from "./OrganizationMember.vue?vue&type=template&id=319e0dfa&scoped=true&"
import script from "./OrganizationMember.vue?vue&type=script&lang=js&"
export * from "./OrganizationMember.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationMember.vue?vue&type=style&index=0&id=319e0dfa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319e0dfa",
  null
  
)

export default component.exports